export default __webpack_public_path__ + "static/media/acceso_perfiles_ilus1.509625c6.svg";